export default "__VITE_ASSET__C8S_cxZP__"